<template>
  <div>
    <div class="scroll-content" :style="{ left, transition }">
      <slot>
      </slot>
      <!-- <div v-for="(item,index) in items.concat(itemsLength>minLimit?items:[])" :key="index">{{ item }}</div> -->
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      itemsLength: 0,
      itemsIndex: 0,
      timeSpan: 0
    }
  },
  props: {
    dataCount: {
      type: Number,
      default: 0
    },
    sourceLength: {
      type: Number,
      default: 0
    },
    minLimit: {
      type: Number,
      default: Infinity
    },
    offSetX: {
      type: Number,
      default: 0
    }
  },
  mounted () {
    this.getdata()
    this.scroll()
  },
  methods: {
    scroll () {
      if (this.dataCount > 0) {
        this.timeSpan = Math.floor(Math.random() * this.dataCount * 1000)
      }
      setTimeout(() => {
        setInterval(() => {
          // eslint-disable-next-line no-debugger
          if (
            this.itemsIndex < this.itemsLength &&
          this.itemsLength > this.minLimit
          ) {
            this.itemsIndex += 1
          } else {
            this.itemsIndex = 0
            this.getdata()
          }
        }, 2000)
      }, this.timeSpan)
    },
    getdata () {
      this.itemsLength = this.sourceLength
    }
  },
  computed: {
    left () {
      return -this.itemsIndex * this.offSetX + 'rem'
    },
    transition () {
      return this.itemsIndex === 0 ? 'none' : 'all 0.5s'
    }
  }
}
</script>
<style scoped>
.scroll-content {
  position: relative;
  height: 100%;
}
</style>
